import { t as tr } from "../../lib/i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, errorMessage } from "../../lib/api";
import { Alert } from "../../components/Form";
import { Progress, Screen, StudyGate, TopBar, levelName, useLang } from "./kit";
import { Art } from "../../ui/Art";
import { Icon } from "../../ui/Icon";

type Subject = { versionId: string; subject: string; nameMs: string; nameEn: string; units: number; unitsReady: number; lessons: number; lessonsDone: number };

export function YearPage() {
  return (
    <Screen>
      <StudyGate>
        <Inner />
      </StudyGate>
    </Screen>
  );
}

function Inner() {
  const { level = "rendah", year = "1" } = useParams();
  const { lang } = useLang();
  const [subjects, setSubjects] = useState<Subject[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api<{ subjects: Subject[] }>(`/api/learn/year/${level}/${year}`).then((r) => setSubjects(r.subjects)).catch((e) => setError(errorMessage(e)));
  }, [level, year]);

  return (
    <>
      <TopBar back="/belajar" title={levelName(level, Number(year))} subtitle={tr("Pilih subjek")} />
      {error && <Alert kind="error">{error}</Alert>}
      <div className="grid gap-3 sm:grid-cols-2">
        {(subjects ?? []).map((s) => {
          const ready = s.unitsReady > 0;
          const card = (
            <div className={`pastel-blue flex items-center gap-4 rounded-3xl p-4 shadow-sm ${ready ? "transition hover:-translate-y-0.5" : "opacity-60"}`}>
              <span className="grid h-20 w-20 shrink-0 place-items-center rounded-2xl bg-sky-50">
                <Art id={`subjek/${s.subject}`} alt="" label={s.nameMs} className="h-[4.5rem] w-[4.5rem]" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-lg font-extrabold text-slate-900">{(lang === "en" ? s.nameEn || s.nameMs : tr(s.nameMs))}</p>
                <p className="text-xs text-slate-500">
                  {ready ? `${s.unitsReady}/${s.units} ${tr("unit sedia")} · ${s.lessonsDone}/${s.lessons} ${tr("pelajaran")}` : tr("Kandungan sedang disediakan")}
                </p>
                {ready && <div className="mt-2"><Progress value={s.lessonsDone} max={s.lessons} /></div>}
              </div>
              {ready && <Icon name="arrow" className="h-6 w-6 text-brand" />}
            </div>
          );
          return ready ? <Link key={s.versionId} to={`/belajar/subjek/${s.versionId}`}>{card}</Link> : <div key={s.versionId}>{card}</div>;
        })}
      </div>
    </>
  );
}
